import React from 'react';
import PropTypes from 'prop-types';
import { Table } from '../../../components/index';

// const linhasPorPagina = 6;

const options = {
  noDataText: 'Nenhuma exigência para o requerimento',
  hideSizePerPage: true,
  sizePerPage: 12,
};

const tableHeaderAnual = [{
  id: 'ano',
  label: 'Ano',
}, {
  id: 'valorReajustado',
  label: 'Valor Reajustado',
}, {
  id: 'indiceReajuste',
  label: 'Índice reajuste',
}, {
  id: 'valorTotal',
  label: 'valor Total',
}];

const DadosResultadoSimulacao = (props) => {
  const formatarLista = () => {
    const listaFormatada = [];
    props.resultadoSimulacao.forEach((resultado) => {
      const resultFormatado = resultado;
      resultFormatado.valorReajustado = resultFormatado.valorReajustado.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 3 });
      listaFormatada.push(resultFormatado);
    });
    return listaFormatada;
  };

  const montaResultadoAnual = () => (
    <Table
      bordered
      data={formatarLista()}
      options={options}
      listaTableHeader={tableHeaderAnual}
      pagination
      scrollTop="Top"
    />
  );

  const tableHeader = [{
    id: 'ano',
    label: 'Ano',
  }, {
    id: 'mes',
    label: 'Mês',
  }, {
    id: 'valorReajustado',
    label: 'Valor Reajustado',
  }, {
    id: 'indiceReajuste',
    label: 'Índice reajuste',
  }, {
    id: 'tipoAtividade',
    label: 'Tipo de Atividade',
  }, {
    id: 'indicadorTeto',
    label: 'Indicador de teto',
  }, {
    id: 'considerado',
    label: 'Considerado',
  }];

  const montaResultadoMensal = () => (
    <Table
      bordered
      data={formatarLista()}
      options={options}
      listaTableHeader={tableHeader}
      pagination
      scrollTop="Top"
    />
  );

  const defineVisao = () => {
    if (props.resultadoSimulacao[0].mes) {
      return montaResultadoMensal();
    }
    return montaResultadoAnual();
  };

  return (
    <React.Fragment>
      {defineVisao()}
    </React.Fragment>
  );
};

DadosResultadoSimulacao.propTypes = {
  resultadoSimulacao: PropTypes.arrayOf().isRequired,
};

export default DadosResultadoSimulacao;



// WEBPACK FOOTER //
// ./src/pages/requerimentos/Aposentadoria/DadosResultadoSimulacao.jsx